import { c as _c } from "react/compiler-runtime";
export const InternalEmailDataTable: React.FC<{
  entries: Record<string, unknown> | Array<[key: string, value: unknown]>;
}> = props => {
  const $ = _c(6);
  let t0;
  if ($[0] !== props.entries) {
    t0 = Array.isArray(props.entries) ? props.entries : Object.entries(props.entries);
    $[0] = props.entries;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const entries = t0;
  let t1;
  if ($[2] !== entries) {
    t1 = entries.map(_temp2);
    $[2] = entries;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <table><tbody>{t1}</tbody></table>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(x) {
  return typeof x === "string" ? x : JSON.stringify(x, null, 4);
}
function _temp2(t0) {
  const [key, value] = t0;
  if (value === null || value === undefined) {
    return null;
  }
  return <tr key={key}><th style={{
      textAlign: "left",
      textTransform: "capitalize",
      paddingRight: "1rem"
    }}><strong>{key}</strong>:</th><td style={{
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    }}>{(Array.isArray(value) ? value : [value]).map(_temp).join(", ")}</td></tr>;
}